import GenericFormModal from "#blocks/Form/GenericFormModal"
import Firebase from "#classes/Firebase"
import { RESOURCES } from "#customTypes/composedTypes/authTypes"
import { DOC_TYPES } from "#customTypes/composedTypes/firebaseTypes"
import {
  AddSemesterFormSubmitValues,
  type AddSemesterFormValues,
} from "#customTypes/composedTypes/semesterTypes"

import AddSemesterForm from "./AddSemesterForm"

export interface AddSemesterFormModalProps {
  onClose: () => void
  initialValues: AddSemesterFormValues | undefined
  onError?: (error: unknown) => void
}

export const AddSemesterFormModal = ({
  onClose,
  initialValues,
}: AddSemesterFormModalProps) => {
  const isEdit = initialValues?.id != null

  // Errors are handled in GenericFormModal
  const handleFinish = async (
    cleanedValues: AddSemesterFormValues
  ): Promise<void> => {
    const data: AddSemesterFormValues | AddSemesterFormSubmitValues =
      cleanedValues

    if (initialValues?.id != null) {
      data.id = initialValues.id
    }

    // TODO: Fix type error - can't submit undefined values
    await Firebase.getInstance().addDocument(DOC_TYPES.SEMESTERS, data)
  }

  const handleDelete = async () => {
    throw new Error("Coming soon!")
  }

  return (
    <GenericFormModal
      title={isEdit ? "Edit Semester" : "Add Semester"}
      onClose={onClose}
      initialValues={initialValues}
      onFinish={handleFinish}
      resource={RESOURCES.SEMESTER}
      onDelete={handleDelete}
    >
      <AddSemesterForm />
    </GenericFormModal>
  )
}

export default AddSemesterFormModal
